import React, { useState, useEffect } from "react";
import { styled } from "styletron-react";
import { Input, SIZE } from "baseui/input";
import { connect } from "react-redux";
import { createParameterItem } from "../../redux/template/TemplateThunk";
import { TREE_ITEM_TYPES } from "../../constants/AppEnums";
import { updateParameterGroup } from "../../redux/template/TemplateThunk";
import DropdownButton from '../../components/drowdown-button/DropDownButtonComponent'; // Assuming DropdownButton is in the same directory

const StyledDiv = styled("div", {
  padding: "10px 20px",
  display: "flex",
  height: "48px", // Adjusted for brevity
  alignItems: "center",
  justifyContent: "space-between",
});
const InputContainer = styled("div", {
  flex: "0 0 auto",
  width: "300px",
});

function TemplateParameterDetailHeaderView(props) {
  const [groupName, setGroupName] = useState(props.currentGroup?.name);

  useEffect(() => {
    setGroupName(props.currentGroup?.name);
  }, [props.currentGroup]);

  const inputItems = [
    {
      label: 'Numeric',
      action: () => addNewItem(TREE_ITEM_TYPES.NUMERIC)
    },
    {
      label: 'Multioption',
      action: () => addNewItem(TREE_ITEM_TYPES.MULTIOPTION)
    },
    {
      label: 'Text',
      action: () => addNewItem(TREE_ITEM_TYPES.TEXT)
    }
    // ...other input types
  ];

  function addNewItem(itemType) {
    let baseName = "NewParameter";
    let newName = baseName;
    let counter = 1;
  
    // Function to check if the name exists in any group's children
    const nameExists = (name) => {
      return (props.groups || []).some(group => 
        group.children && (group?.children || []).some(child => child.name === name)
      );
    };
  
    // Keep incrementing the counter until a unique name is found
    while (nameExists(newName)) {
      newName = `${baseName}_${counter}`;
      counter++;
    }    
    const newItem = {
      name: newName,
      type: itemType,
      displayName: newName,
      // Provide default values based on the item type
      ...(itemType === TREE_ITEM_TYPES.NUMERIC && {
        defaultValue: "0",
        minValue: "0",
        maxValue: "1",
        step: "0.5",
      }),
      ...(itemType === TREE_ITEM_TYPES.MULTIOPTION && {
        defaultValue: "Default",
        optionsList: ["Default"],
      }),
      ...(itemType === TREE_ITEM_TYPES.TEXT && {
        defaultValue: "Default",
      }),
      // ...other item type configurations
    };
    props.onAddNewItem(props.currentGroup.id, newItem);
    props.onItemsChanged();
  }

  return (
    <StyledDiv>
      <InputContainer>
        <Input
          size={SIZE.compact}
          value={groupName || ""}
          onChange={(e) => setGroupName(e.target.value)}
          onBlur={() => {
            props.onUpdateParameterGroup({
              group: {
                id: props.currentGroup.id,
                name: groupName,
              }
            });
          }}
          disabled={!props.currentGroup}
        />
      </InputContainer>
      {props.currentGroup && (
        <DropdownButton items={inputItems} />
      )}
    </StyledDiv>
  );
}

const mapStateToProps = (state) => ({
  currentGroup: state.template.activeTemplate?.selectedGroup,
  groups : state.template.activeTemplate?.parameterGroups,
  inProgress: state.template.activeTemplate?.inProgress,
});

const mapDispatchToProps = (dispatch) => ({
  onAddNewItem: (groupId, item) => dispatch(createParameterItem(groupId, item)),
  onUpdateParameterGroup: ({group}) => dispatch(updateParameterGroup(group)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateParameterDetailHeaderView);
